import { deduplicate } from 'functions/deduplicate';
import { BACKDROP_CONSTANTS } from './constants';

const initialState = {
  isShown: false,
  shownAt: null,
  type: null,
  reasons: [],
};

// eslint-disable-next-line default-param-last
export function backdrop(state = initialState, action) {
  const { type: actionType, payload } = action;
  switch (actionType) {
    case BACKDROP_CONSTANTS.SHOW_BACKDROP: {
      const {
        shownAt, type, isShown, reasons,
      } = state;
      const { shownAt: payloadShownAt, type: payloadType, reason } = payload;
      const nextShownAt = isShown && type === payloadType ? shownAt : payloadShownAt;
      const nextReasons = type === payloadType ? deduplicate([...reasons, reason]) : [reason];
      return {
        shownAt: nextShownAt, isShown: true, type: payloadType, reasons: nextReasons,
      };
    }
    case BACKDROP_CONSTANTS.HIDE_BACKDROP: {
      const { reasons } = state;
      const { reason: payloadReason } = payload;
      const nextReasons = reasons.filter((reason) => reason !== payloadReason);
      const nextIsShown = !!nextReasons.length;
      return nextIsShown ? {
        ...state,
        isShown: true,
        reasons: nextReasons,
      } : { ...initialState };
    }
    case BACKDROP_CONSTANTS.HIDE_BACKDROP_IMMEDIATELY: {
      return { ...initialState };
    }
    default:
      return state;
  }
}
